import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { FilterListRequestParameters } from '../../models/filter.model';
import { baseQuery } from './base.query';

export interface FilterResponse {
  name: string;
  value: string;
  alias?: string;
  items?: FilterResponse[];
}

export const filterApi = createApi({
  reducerPath: 'filtersApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getFilterValues: builder.query<FilterResponse[], FilterListRequestParameters>({
      query: (args) => ({
        url:
          `${API_PREFIX.NEXTGEN}${API.FILTERS}/${args.filterParent}?filterType=${args.filterString}&startDate=${args.startDate}&endDate=${args.endDate}&includeAlignment=${args.includeAlignment ? 'true' : 'false'}` +
          (args.questionId && args.questionId > 0 ? `&filter_questionId=${args.questionId}` : ''),
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFilterValuesQuery } = filterApi;
